/*
 * @Author: chenxing
 * @Date: 2021-04-01 11:19:07
 * @LastEditors: Yran
 * @LastEditTime: 2021-05-07 18:16:16
 */
import axios from '@/utils/axios';

const apiUrl = {
    projectList: '/sys/project/list',
    projectListByUser: '/sys/project/getListByUserId',
    projectListByCompanyName: '/sys/project/getPageByCompanyName',
    projectListPage: '/sys/project/queryPageOneCompanyMore '
};

export function getProjectListData(params) {
    return axios.post(apiUrl.projectList, params);
}

export function getProjectListByUser() {
    return axios.get(apiUrl.projectListByUser);
}

export function getProjectListByCompanyName(params) {
    return axios.post(apiUrl.projectListByCompanyName, params);
}

export function getProjectListPageData(params) {
    return axios.post(apiUrl.projectListPage, params);
}